module.exports = __webpack_public_path__ + "img/hg-1.8943e27e.jpg";